import React from 'react';
export const Button = ({ type, children, className, onClick, testId, }) => {
    return (React.createElement("button", { "data-testid": testId, type: type || 'button', className: `button ${className || ''}`, onClick: onClick }, children));
};
export const BlockButton = ({ type, children, className, onClick, }) => {
    return (React.createElement("button", { type: type || 'button', className: `button button--block ${className || ''}`, onClick: onClick }, children));
};
